export const CloseButton = ({ className = '' }) => {
  return (
    <svg
      className={className}
      width="12"
      height="11"
      viewBox="0 0 12 11"
      fill="none"
    >
      <rect
        x="0.648438"
        y="9.84375"
        width="14.087"
        height="1.4087"
        rx="0.704351"
        transform="rotate(-45 0.648438 9.84375)"
        fill="#444444"
      />
      <rect
        x="1.64844"
        y="-0.117188"
        width="14.087"
        height="1.4087"
        rx="0.704351"
        transform="rotate(45 1.64844 -0.117188)"
        fill="#444444"
      />
    </svg>
  )
}
